import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isClubOwner } from "../../../utils/roles";
import AdminOwnerMemberProfile from "./AdminOwnerMemberProfile";
import AdminOwnerProfileAccount from "./AdminOwnerProfileAccount";

function OwnerOnly({ children }) {
  const { role, profile, club } = useSelector((state) => state.auth);
  if (!isClubOwner({ role, profileRole: profile?.role, club })) {
    return <Navigate to="/manage/app/more" replace />;
  }
  return children;
}

export default function AdminOwnerProfile() {
  return (
    <OwnerOnly>
      <Routes>
        <Route index element={<AdminOwnerMemberProfile />} />
        <Route path="account/*" element={<AdminOwnerProfileAccount />} />
        <Route
          path="settings"
          element={<Navigate to="/manage/app/profile/account" replace />}
        />
        <Route path="*" element={<Navigate to="/manage/app/profile" replace />} />
      </Routes>
    </OwnerOnly>
  );
}
